import { parse, differenceInSeconds } from 'date-fns'

const CountTimerObj = {
    el: null,
    time: null,
    interval: null,
    days: null,
    hours: null,
    mins: null,
    seconds: null
}

const ONE_DAY = 60 * 60 * 24
const ONE_HOUR = 60 * 60
const ONE_MINUTE = 60

export function CountdownTimer(context = document) {
    const Els = context.querySelectorAll('.js-countdown')
    return Array.from(Els).map(createCountdownTimer)
}

function createCountdownTimer(el) {
    const Obj = { ...CountTimerObj }
    init.call(Obj, el)
    return Obj
}

function init(el) {
    this.el = el

    this.time = this.el.querySelector('[data-time]')
    this.time = parse(this.time.dataset.time, 'dd/MM/yy HH:mm', new Date())
    this.day = this.el.querySelector('.js-countdown-day')
    this.hours = this.el.querySelector('.js-countdown-hours')
    this.mins = this.el.querySelector('.js-countdown-mins')
    this.seconds = this.el.querySelector('.js-countdown-seconds')

    setInterval(() => {
        update.call(this)
    }, 1000)
}

function update() {
    const { days, hours, minutes, seconds } = getTime.call(this)

    this.day.innerText = days
    this.hours.innerText = hours
    this.mins.innerText = minutes
    this.seconds.innerText = seconds
}

function getTime() {
    const diffInSeconds = differenceInSeconds(this.time, new Date())

    if (diffInSeconds <= 1) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }

    const days = Math.floor(diffInSeconds / ONE_DAY)
    const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR)
    const minutes = Math.floor((diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE)
    const seconds = diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE

    return {
        days,
        hours,
        minutes,
        seconds
    }
}
